import React from "react";

const Statements = () => {
  return (
    <div>
      <h1>Statements Component</h1>
      <p>Content for Statements goes here...</p>
    </div>
  );
};

export default Statements;
